import $ from "jquery";

class CookiesConsent {
	constructor(lang, mandatory) {
		this.cookiesLinks = document.querySelectorAll('.cookie-link');
        this.supportedTaCLanguages = ['fr', 'en', 'de', 'es', 'it', 'pt', 'pl', 'ru'];

        if( mandatory = true ) {
            window.addEventListener("tac.root_available", function() {
                // Si cookie TaC présent ne rien faire
                if(!tarteaucitron.cookie.read().match(/=(true|false)/g)) {
                    document.querySelector('#tarteaucitronRoot').classList.add('opened');
                }
            });
            
            window.addEventListener("tac.open_panel", function() {
                document.querySelector('#tarteaucitronRoot').classList.add('opened');
            });
            window.addEventListener("tac.close_panel", function() {
                document.querySelector('#tarteaucitronRoot').classList.remove('opened');
            });
            window.addEventListener("tac.close_alert", function() {
                document.querySelector('#tarteaucitronRoot').classList.remove('opened');
            });
        }
        
        if(lang && this.supportedTaCLanguages.indexOf(lang) !== -1) {
            // Set TaC language
    		this._setLang(lang);
        }

        // Bind links to open TaC panel another time after cookies acceptance
		if(this.cookiesLinks.length) {
			this._bindCookiesLinks();
		}
	}

	_bindCookiesLinks() {
        this.cookiesLinks.forEach(function(link) {
            link.addEventListener('click', tarteaucitron.userInterface.openPanel, false);
        });
	}

	_setLang(lang) {
		window.tarteaucitronForceLanguage = lang;
	}

}

export default CookiesConsent;
